/**
 * External dependencies
 */
import { Component } from '@wordpress/element';
import {DateTimePicker, Popover} from '@wordpress/components';
import moment from 'moment';

/**
 * Internal dependencies
 */
import './style.scss';

class DatePickerPopoverMonth extends Component {
	constructor( props ) {
		super( props );
		this.state = {
			showPicker: false,
		};

		this.handleChange = this.handleChange.bind( this );
		const picker = this;

		document.addEventListener( 'click', function( event ) {
			let element = document.getElementById( 'wc-bookings-datepicker-toggle-month' );

			if ( event.target === element || element.contains( event.target ) ) {
				return;
			}

			if ( event.target.closest( '.wc-bookings-datepicker-popover' ) ) {
				return;
			}

			picker.setState( {
				showPicker: false,
			} );
		} );
	}

	handleChange( datetime ) {
		const date = datetime.substring( 0, 10 );
		document.location.search += '&calendar_day=' + date + '&view=day';
	}

	toggleVisibility() {
		const { showPicker } = this.state;
		this.setState( {
			showPicker: ! showPicker,
		} );
	}

	render() {
		const { showPicker } = this.state;
		const { year, month } = this.props;

		return (
			<div>
				<a href="#" onClick={ (e) => { e.preventDefault(); this.toggleVisibility() } } id="wc-bookings-datepicker-toggle-month">
					{ month } { year } <span> &#9662;</span>
				</a>
				{ showPicker && (
					<Popover className="wc-bookings-datepicker-popover">
						<DateTimePicker
							onChange={this.handleChange}
							currentDate={ moment( '01 ' + month + ' ' + year, 'DD MMM YYYY' ).toDate() }
							__nextRemoveHelpButton
							__nextRemoveResetButton
						/>
					</Popover>
				) }
			</div>
		);
	}

}
export default DatePickerPopoverMonth;
